export default __webpack_public_path__ + "static/media/kiranprakashan.87f3f792.png";